import orderBy from 'lodash/orderBy'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from '../i18n'

import { IPriceOption, ITuitionProgram } from 'main/gql/schoolTuitionProgram'
import { Label, Text } from 'main/ui'
import { formatCurrency } from 'main/util/currency'
import { formatTime } from 'main/util/time'
import { PaymentFrequencyOption } from './PaymentFrequency'

import { HeaderContainer, PriceOptionContainer } from './DetailedPricingTable.styles'

const PRE = `${i18nKeyPrefix}-DETAILED-TABLE`

interface IProps {
  tuitionProgram: ITuitionProgram
  paymentFrequency: PaymentFrequencyOption
}

export default function DetailedPricingTable(props: IProps) {
  const { tuitionProgram, paymentFrequency } = props
  const { hoursStart, hoursEnd, name, priceOptions } = tuitionProgram

  return (
    <>
      <HeaderContainer>
        <Label muted>{name}</Label>
        <Text muted>
          {formatTime(hoursStart)} - {formatTime(hoursEnd)}
        </Text>
      </HeaderContainer>
      {orderedPriceOptions(priceOptions).map((priceOption, index) => (
        <PriceOptionContainer key={index}>
          <PriceOption priceOption={priceOption} paymentFrequency={paymentFrequency} />
        </PriceOptionContainer>
      ))}
    </>
  )
}

interface IPriceOptionProps {
  priceOption: IPriceOption
  paymentFrequency: PaymentFrequencyOption
}

function PriceOption(props: IPriceOptionProps) {
  const { priceOption, paymentFrequency } = props
  const { daysPerWeek, monthlyRate, weeklyRate } = priceOption
  const { t } = useTranslation(NAMESPACE)

  const rate = paymentFrequency === PaymentFrequencyOption.monthly ? monthlyRate : weeklyRate
  const periodicity = paymentFrequency === PaymentFrequencyOption.monthly ? 'month' : 'week'

  return (
    <>
      <Text>{t(`${PRE}-DAYS-PER-WEEK`, { count: daysPerWeek })}</Text>
      <Text>{rate ? `${formatCurrency(rate)} / ${periodicity}` : 'n/a'}</Text>
    </>
  )
}

function orderedPriceOptions(priceOptions: IPriceOption[]): IPriceOption[] {
  return orderBy(priceOptions, ['daysPerWeek'], ['desc'])
}
